import React, { useState, useEffect } from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import { Typography, useMediaQuery } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setScDSAMeasureNumber, setScDSAMeasure } from "./editScenarioNewSlice";

const addBtnText = "Add >";
const remBtnText = "< Remove";

function not(a, b) {
	return a.filter((value) => b.indexOf(value) === -1);
}

function intersection(a, b) {
	return a.filter((value) => b.indexOf(value) !== -1);
}

export default function TransferListDSAMeasure({
	leftList,
	rightList,
	scDSAInd,
}) {
	const [checked, setChecked] = useState([]);
	const [left, setLeft] = useState([]);
	const [right, setRight] = useState([]);
	const [countLeft, setCountLeft] = useState(0);
	const [countRight, setCountRight] = useState(0);

	const leftChecked = intersection(checked, left);
	const rightChecked = intersection(checked, right);

	const isTab = useMediaQuery("(max-width: 800px)");

	const { scDSA } = useSelector((store) => store.editScenarioNew);
	const dispatch = useDispatch();

	useEffect(() => {
		if (leftList?.length >= 0) {
			setLeft(leftList);
		}
		if (rightList?.length >= 0) {
			setRight(rightList);
		}
	}, [leftList, rightList]);

	useEffect(() => {
		setCountLeft(left.length);
		setCountRight(right.length);
	}, [left, right]);

	const handleToggle = (value) => () => {
		const currentIndex = checked.indexOf(value);
		const newChecked = [...checked];

		if (currentIndex === -1) {
			newChecked.push(value);
		} else {
			newChecked.splice(currentIndex, 1);
		}

		setChecked(newChecked);
	};

	const handleCheckedRight = () => {
		const tempRight = right.concat(leftChecked);
		const tempLeft = not(left, leftChecked);
		if (tempRight.length < 2) {
			setRight(tempRight);
			setLeft(tempLeft);
			setChecked(not(checked, leftChecked));

			const measureValue = tempRight[0].measureValue;
			dispatch(setScDSAMeasureNumber(scDSAInd, measureValue));
			dispatch(setScDSAMeasure(scDSAInd, tempLeft, false));
			dispatch(setScDSAMeasure(scDSAInd, tempRight, true));
		}
		console.log(scDSA[scDSAInd].measure);
	};

	const handleCheckedLeft = () => {
		const tempRight = not(right, rightChecked);
		const tempLeft = left.concat(rightChecked);
		setLeft(tempLeft);
		setRight(tempRight);
		setChecked(not(checked, rightChecked));

		const measureValue = tempRight[0].measureValue;
		dispatch(setScDSAMeasureNumber(scDSAInd, measureValue));
		dispatch(setScDSAMeasure(scDSAInd, tempLeft, false));
		dispatch(setScDSAMeasure(scDSAInd, tempRight, true));
	};

	const customList = (items, count) => (
		<>
			{/* <Typography variant="subtitle2">Count: {count}</Typography> */}
			<Paper
				sx={{ width: isTab ? 300 : "30vw", height: 160, overflow: "auto", border: "1px solid #c6c6c6" }}
			>
				<List dense component="div" role="list">
					{items.map((item, index) => {
						const labelId = `transfer-list-item-${item}-label`;

						return (
							<ListItem sx={{height: "40px", marginTop: .5,}}
								key={index}
								role="listitem"
								button
								onClick={handleToggle(item)}
							>
								<ListItemIcon>
									<Checkbox
										checked={checked.indexOf(item) !== -1}
										tabIndex={-1}
										disableRipple
										inputProps={{
											"aria-labelledby": labelId,
										}}
									/>
								</ListItemIcon>
								<ListItemText
									id={labelId}
									primary={`${item.measureName}`}
								/>
							</ListItem>
						);
					})}
				</List>
			</Paper>
		</>
	);

	return (
		<Grid container spacing={2} justifyContent="space-between" alignItems="center">
			<Grid item>{customList(left, countLeft)}</Grid>
			<Grid item>
				<Grid container direction="column" alignItems="center">
					<Button
						sx={{ my: 0.5, }}
						variant="outlined"
						size="small"
						onClick={handleCheckedRight}
						disabled={leftChecked.length === 0}
						aria-label="move selected right"
					>
						{addBtnText}
					</Button>
					<Button
						sx={{ my: 0.5 }}
						variant="outlined"
						size="small"
						onClick={handleCheckedLeft}
						disabled={rightChecked.length === 0}
						aria-label="move selected left"
					>
						{remBtnText}
					</Button>
				</Grid>
			</Grid>
			<Grid item>{customList(right, countRight)}</Grid>
		</Grid>
	);
}
